<template>
  <div class="l-fixed l-height-100 sidebar">
    <a class="sidebar-toggle" v-on:click="toggleSidebar()">
      <i class="material-icons sidebar-menu-icon">menu</i>
      <i class="material-icons sidebar-close-icon">close</i> <span>Hide Sidebar</span>
    </a>
    <Navigation></Navigation>
    <Contact></Contact>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Contact from '@/components/about/Contact'

export default {
  name: 'sidebar',

  components: {
    'Navigation': Navigation,
    'Contact': Contact
  },

  methods: {
    toggleSidebar: function (event) {
      let app = document.getElementById('app')
      app.classList.toggle('s-sidebar-toggled')

      let navToggles = document.getElementsByClassName('nav-toggle')

      for (let key in navToggles) {
        if (typeof navToggles[key].classList !== 'undefined') {
          navToggles[key].parentElement.classList.remove('active')
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/sidebar";
</style>



// WEBPACK FOOTER //
// Sidebar.vue?8c57dc46